import { render, staticRenderFns } from "./notificationSidebar.vue?vue&type=template&id=3cbc0147&"
import script from "./notificationSidebar.vue?vue&type=script&lang=js&"
export * from "./notificationSidebar.vue?vue&type=script&lang=js&"
import style0 from "./notificationSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports